<template>
  <genera-fatture-clienti-energia />
</template>

<script>
import GeneraFattureClientiEnergia from '@/components/ask/pages/GeneraFattureClientiEnergia.vue'

export default {
  name: 'PageGeneraFattureClientiEnergia',

  components:{
    GeneraFattureClientiEnergia
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
